var path = 'app/scripts/modules/core/src/notification/selector/notificationSelector.html';
var html = "<div class=\"form-group row\">\n  <div class=\"col-sm-3 sm-label-right\" id=\"type\">Notify via</div>\n  <div class=\"col-sm-9\">\n    <select class=\"input-sm\"\n            ng-options=\"t.key as t.label for t in vm.notificationTypes\"\n            ng-model=\"vm.notification.type\"\n            ng-change=\"vm.updateNotificationType()\">\n    </select>\n  </div>\n</div>\n<div ng-include=\"vm.addressTemplateUrl\"></div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/scripts/modules/core/src/notification/selector/notificationSelector.html
// module id = 1101
// module chunks = 0